import BuildTypes from 'src/constants/BuildTypeConstants';
import Styles from 'src/components/Styles';
import Settings from 'src/Settings';

const offersThemeConfiguration = {
  [BuildTypes.canteen]: {
    buttonColor: Styles.primaryColor,
    textFontFamily: Styles.FontFamily.robotoRegular,
    textColor: Styles.darkColor,
  },
  [BuildTypes.default]: {
    buttonColor: Styles.Colors.PayNew.primary01,
    textFontFamily: Styles.FontFamily.aeonikRegular,
    textColor: Styles.Colors.PayNew.black01,
  },
  [BuildTypes.refive]: {
    buttonColor: Styles.Colors.PayNew.primary01,
    textFontFamily: Styles.FontFamily.figtreeRegular,
    textColor: Styles.Colors.PayNew.black01,
  },
};

export const offersTheme = offersThemeConfiguration[Settings.buildType];
